import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { OnboardingFacade } from '../../../Facades/onboarding.facade';

export const planSelectionGuard: CanActivateFn = () => {
  const hasOffer = inject(OnboardingFacade).onboarding()?.hasCustomOffer() ?? false;
  return hasOffer ? inject(Router).createUrlTree(['/setup/admin-consent']) : true;
};
